import { combineReducers } from 'redux';

import loadingReducer from 'modules/global/reducers/generic.loading';
import createSearchReducers from 'modules/global/reducers/simpleSearchReducer';
import * as types from 'modules/payments/actionTypes';

import filters from './filters';
import modalVisibleReducer from './isExportModalVisible';
import total from './total';

export default combineReducers({
  dashboard: combineReducers({
    filters,
    data: createSearchReducers(types.FETCH_PAYMENTS, {
      global: { matcher: ({ meta }) => meta?.source === 'payments-dashboard', paginationSlice: true },
    }),
    amount: combineReducers({
      total,
      loading: loadingReducer(types.FETCH_TOTAL_AMOUNT, {
        global: { matcher: ({ meta }) => meta?.source === 'payments-dashboard' },
      })
    }),
    visible: modalVisibleReducer,
    loading: loadingReducer(types.EXPORT_PAYMENT_REQUEST)
  })
});
